import React, { useEffect, useRef, useState } from 'react'
import { Redirect, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { accessTokenLogin } from 'modules/session/session-actions'
import { getCsrfToken, isSessionCookiesEnabled, resolveRedirect } from 'utils/sessionSharing'
import Auth from './index'

// /auth/sign-in for a user who is ALREADY signed in (it used to render nothing):
// - flag off, or no / non-allow-listed redirectTo: go to /home
// - flag on and an allow-listed absolute redirectTo (the Sou-Sou site): go there when the shared session cookie exists
//   (its readable CSRF twin is present); otherwise call accessTokenLogin first (the backend can set the cookie when a
//   valid bearer is presented) and, if the cookie is still missing, show the login form so a fresh login sets it.
export const HANDOFF_KEY = 'tl-signin-handoff'
export const HANDOFF_GUARD_MS = 15000

// Loop guard: the Sou-Sou site sends signed-out visitors back here; if we just sent this browser there, the cookie it
// has is not accepted, so show the login form instead of bouncing again.
const recentlyHandedOff = () => {
  try {
    const last = Number(window.sessionStorage.getItem(HANDOFF_KEY))
    return !!last && Date.now() - last < HANDOFF_GUARD_MS
  } catch (error) {
    return false
  }
}
const markHandedOff = () => {
  try {
    window.sessionStorage.setItem(HANDOFF_KEY, String(Date.now()))
  } catch (error) {}
}

const SignedInSignIn = props => {
  const dispatch = useDispatch()
  const { search } = useLocation()
  const mounted = useRef(true)
  const target = new URLSearchParams(search).get('redirectTo')
  const resolved = isSessionCookiesEnabled() ? resolveRedirect(target, '/home') : null
  const url = resolved && resolved.external ? resolved.url : null

  const initial = () => {
    if (!url) return 'home'
    if (recentlyHandedOff()) return 'login'
    return getCsrfToken() ? 'go' : 'mint'
  }
  const [phase, setPhase] = useState(initial)

  useEffect(() => () => { mounted.current = false }, [])

  useEffect(() => {
    if (phase === 'go') {
      markHandedOff()
      window.location.assign(url)
    } else if (phase === 'mint') {
      Promise.resolve(dispatch(accessTokenLogin({ deviceType: 'WEB' })))
        .then(() => {
          if (!mounted.current) return
          if (!getCsrfToken()) setPhase('login')
          else if (recentlyHandedOff()) setPhase('login')
          else setPhase('go')
        })
        .catch(() => mounted.current && setPhase('login'))
    }
  }, [phase, url, dispatch])

  if (phase === 'home') return <Redirect to='/home' />
  if (phase === 'login') return <Auth {...props} />
  return null
}

export default SignedInSignIn
